import {Controller} from "stimulus"

export default class extends Controller {
    static targets = [
        "sourceSelect",
    ]

    navigate() {
        let targetPath = this.sourceSelectTarget.options[this.sourceSelectTarget.selectedIndex].dataset.targetPath;
        Turbolinks.visit(targetPath);
    }

}